module.exports = __webpack_public_path__ + "img/fail.2007a207.png";